// src/AuthContext.js

import React, { createContext, useState, useEffect, useContext, useMemo } from 'react';

// Ancien import incorrect :
// import { Hub, fetchAuthSession, getCurrentUser, signOut } from 'aws-amplify/auth';

// Nouveaux imports corrects :
import { fetchAuthSession, getCurrentUser, signOut } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkCurrentUser = async () => {
      try {
        await fetchAuthSession(); 
        const currentUser = await getCurrentUser();
        setUser(currentUser);
      } catch (error) {
        setUser(null);
      }
      setIsLoading(false);
    };

    checkCurrentUser();

    const hubListener = (data) => {
      if (data.payload.event === 'signedIn') checkCurrentUser();
      if (data.payload.event === 'signedOut') setUser(null);
    };

    const unsubscribe = Hub.listen('auth', hubListener);
    return () => unsubscribe();
  }, []);

  const value = useMemo(() => ({ 
    user, 
    isLoading, 
    signOut 
  }), [user, isLoading]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);